<template>
    <div class="media-showcase" @click="goToMedia">
        <div class="showcase-inner">
            <!-- 左侧视频预览区 -->
            <div class="video-preview">
                <div class="preview-wrapper">
                    <img class="preview-cover" :src="previewCover" alt="视频预览" />
                    <div class="preview-overlay">
                        <div class="play-icon">
                            <i class="el-icon-video-play"></i>
                        </div>
                    </div>
                    <div class="duration-badge">
                        <i class="el-icon-video-camera"></i>
                        <span>{{ videoDuration }}</span>
                    </div>
                </div>
            </div>

            <!-- 右侧内容区 -->
            <div class="content-info">
                <div class="info-wrapper">
                    <div class="section-badge">
                        <span class="badge-dot"></span>
                        <span class="badge-text">影像纪事</span>
                    </div>

                    <h3 class="title">探索光影世界</h3>

                    <p class="description">
                        用镜头记录美好瞬间，通过影像讲述动人故事。<br>
                        精选高清视频内容，带来沉浸式视觉体验。
                    </p>

                    <div class="feature-list">
                        <div class="feature-item">
                            <i class="el-icon-check"></i>
                            <span>精美展览内容</span>
                        </div>
                        <div class="feature-item">
                            <i class="el-icon-check"></i>
                            <span>酒店介绍内容</span>
                        </div>
                        
                    </div>

                    <div class="action-button">
                        <span>查看更多视频</span>
                        <i class="el-icon-arrow-right"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MediaShowcase',
    data() {
        return {
            previewCover: 'https://www.hqhotel5.com/img/hotelImgs/poster/1.png',
            videoDuration: '2:30'
        };
    },
    methods: {
        goToMedia() {
            this.$router.push('/media');
        }
    }
};
</script>

<style lang="scss" scoped>
.media-showcase {
    width: 100%;
    max-width: 1000px;
    margin: 0 auto;
    cursor: pointer;

    .showcase-inner {
        display: flex;
        gap: 48px;
        background: rgba(255, 255, 255, 0.9);
        backdrop-filter: blur(20px);
        border-radius: 28px;
        padding: 24px;
        transition: all 0.4s cubic-bezier(0.2, 0.9, 0.4, 1.1);
        border: 1px solid rgba(201, 162, 59, 0.15);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04);

        &:hover {
            transform: translateY(-6px);
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
            border-color: rgba(201, 162, 59, 0.3);
            background: rgba(255, 255, 255, 0.98);

            .video-preview .preview-overlay {
                opacity: 1;
            }

            .action-button {
                background: #c9a23b;

                span,
                i {
                    color: white;
                }

                i {
                    transform: translateX(6px);
                }
            }
        }
    }

    // 左侧视频预览
    .video-preview {
        flex-shrink: 0;
        width: 280px;

        .preview-wrapper {
            position: relative;
            width: 100%;
            padding-bottom: 75%; // 4:3 比例
            border-radius: 20px;
            overflow: hidden;
            box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);

            .preview-cover {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                object-fit: cover;
                transition: transform 0.5s ease;
            }

            .preview-overlay {
                position: absolute;
                inset: 0;
                background: rgba(0, 0, 0, 0.4);
                display: flex;
                align-items: center;
                justify-content: center;
                opacity: 0;
                transition: opacity 0.3s ease;

                .play-icon {
                    width: 56px;
                    height: 56px;
                    background: white;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: transform 0.3s ease;

                    i {
                        font-size: 24px;
                        color: #c9a23b;
                        margin-left: 3px;
                    }
                }
            }

            .duration-badge {
                position: absolute;
                bottom: 12px;
                right: 12px;
                background: rgba(0, 0, 0, 0.7);
                backdrop-filter: blur(8px);
                padding: 4px 10px;
                border-radius: 20px;
                display: flex;
                align-items: center;
                gap: 6px;
                font-size: 12px;
                color: white;

                i {
                    font-size: 12px;
                }
            }
        }

        &:hover .preview-cover {
            transform: scale(1.05);
        }
    }

    // 右侧内容
    .content-info {
        flex: 1;
        display: flex;
        align-items: center;

        .info-wrapper {
            width: 100%;
        }

        .section-badge {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 16px;

            .badge-dot {
                width: 6px;
                height: 6px;
                background: #c9a23b;
                border-radius: 50%;
                animation: pulse 2s ease-in-out infinite;
            }

            .badge-text {
                font-size: 13px;
                font-weight: 500;
                color: #c9a23b;
                text-transform: uppercase;
                letter-spacing: 1px;
            }
        }

        .title {
            font-size: 28px;
            font-weight: 600;
            margin: 0 0 16px 0;
            color: #1a2c3e;
            line-height: 1.3;
        }

        .description {
            font-size: 15px;
            line-height: 1.6;
            color: rgba(26, 44, 62, 0.7);
            margin: 0 0 24px 0;
        }

        .feature-list {
            display: flex;
            flex-wrap: wrap;
            gap: 16px;
            margin-bottom: 32px;

            .feature-item {
                display: flex;
                align-items: center;
                gap: 6px;

                i {
                    font-size: 14px;
                    color: #c9a23b;
                    font-weight: bold;
                }

                span {
                    font-size: 13px;
                    color: rgba(26, 44, 62, 0.8);
                }
            }
        }

        .action-button {
            display: inline-flex;
            align-items: center;
            gap: 10px;
            padding: 12px 28px;
            background: rgba(201, 162, 59, 0.12);
            border-radius: 40px;
            transition: all 0.3s ease;

            span {
                font-size: 15px;
                font-weight: 500;
                color: #c9a23b;
                transition: color 0.3s ease;
            }

            i {
                font-size: 14px;
                color: #c9a23b;
                transition: all 0.3s ease;
            }
        }
    }
}

@keyframes pulse {

    0%,
    100% {
        opacity: 0.5;
        transform: scale(1);
    }

    50% {
        opacity: 1;
        transform: scale(1.2);
    }
}

// 响应式适配
@media (max-width: 768px) {
    .media-showcase {
        max-width: 100%;
        padding: 0 20px;

        .showcase-inner {
            flex-direction: column;
            gap: 24px;
            padding: 20px;
        }

        .video-preview {
            width: 100%;

            .preview-wrapper {
                padding-bottom: 56.25%; // 16:9 比例
            }
        }

        .content-info {
            .title {
                font-size: 24px;
            }

            .feature-list {
                gap: 12px;
            }

            .action-button {
                padding: 10px 24px;
            }
        }
    }
}

@media (min-width: 1200px) {
    .media-showcase {
        max-width: 1100px;

        .video-preview {
            width: 320px;
        }

        .title {
            font-size: 32px;
        }
    }
}
</style>